// Holt ein eben aufgeklapptes Detail ins Bild — so wenig wie nötig (`block: 'nearest'`): steht es
// schon ganz im Fenster, bewegt sich nichts. Wer Bewegung reduziert hat, bekommt einen Sprung statt
// eines Gleitens.
import { useEffect } from 'react'

export function useInsBild(elementId: string | null, bereit = true): void {
  useEffect(() => {
    if (elementId === null || !bereit) return
    const element = document.getElementById(elementId)
    if (element === null || typeof element.scrollIntoView !== 'function') return
    const ruhig = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    // inline: 'nearest' — nur senkrecht nachführen; eine breite Tabelle soll nicht seitlich springen.
    element.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: ruhig ? 'auto' : 'smooth' })
  }, [elementId, bereit])
}
